




import Vue from 'vue'
import Component from 'vue-class-component'
import { Hooks } from '@/shared/interfaces/hooks'
import { Prop } from 'vue-property-decorator'
import { enhanceVideoPlayers } from '@/shared/utils/enhance-video-players'
import { addIframeCaptions } from '@/shared/utils/add-iframe-captions'

@Component({
  name: 'respondeco-editor-live-view',
})
export default class RespondecoEditorLiveView extends Vue implements Hooks {
  @Prop({
    type: String,
  })
  public readonly content!: string

  get html(): string {
    // Set the preload attribute to none because when mounted all video elements will be
    // enhanced with plyr (js video player) and this will set the preload to metadata after
    // the plyr instance has been initialized. This way the metadata of a video is not fetched
    // twice.
    return this.content?.replace('preload="metadata"', 'preload="none"') || ''
  }

  mounted() {
    enhanceVideoPlayers('.respondeco-editor__live-view video')

    addIframeCaptions('.respondeco-editor__live-view iframe')
  }
}
